module.exports = __webpack_public_path__ + "h5/img/logo2.32c3a9ee.png";